import React from 'react';
import { Document, Page, Text, Image, StyleSheet, Font, View } from '@react-pdf/renderer';
import * as _ from 'lodash';

let allowedKeys = {
    Name: 'name',
    'Allowed Redeems': 'noOfAllowRedeems',
    'Redeem Count': 'redeemedCount',
    'Required Points': 'requiredPoints',
    Status: 'status',
    Validity: 'validity'
};
const AgencyRewardsPdf = ({ agencyData, rewards }) => {
    return (
        <Document>
            <Page style={styles.body}>
                <View style={styles.mainContainer}>
                    <View style={styles.flexWidth25}>
                        <View>{agencyData?.logo ? <Image src={agencyData?.logo} style={{ maxWidth: 100, maxHeight: 100 }} /> : <Text>No image available</Text>}</View>
                    </View>
                    <View style={styles.flexWidth75}>
                        <View style={styles.mainContainer}>
                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Email</Text>
                                <Text style={styles.subtitle}>{agencyData?.email}</Text>
                            </View>

                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Name</Text>
                                <Text style={styles.subtitle}>{agencyData?.name}</Text>
                            </View>
                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Phone Number</Text>
                                <Text style={styles.subtitle}>{agencyData?.phone_no}</Text>
                            </View>

                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Transit Type</Text>
                                <Text style={styles.subtitle}>{_.capitalize(agencyData?.transit_mediums?.join(', '))}</Text>
                            </View>

                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Total Commuters</Text>
                                <Text style={styles.subtitle}>{agencyData?.noOfCommuters}</Text>
                            </View>
                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Number of Routes</Text>
                                <Text style={styles.subtitle}>{agencyData?.noOfRoutes}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View>
                    <View style={{ ...styles.mainContainer, ...styles.backgroundHeading }}>
                        {Object.keys(allowedKeys).map((key, index) => {
                            return <Text style={{ ...styles.subtitle, ...styles.flexwidthRow, ...styles.textWhite, ...styles.textCenter(index) }}>{key}</Text>;
                        })}
                    </View>
                    <View style={{ ...styles.mainContainer }}>
                        {rewards.map((dataObj) => {
                            return (
                                <>
                                    {Object.values(allowedKeys).map((key, index) => {
                                        return (
                                            <Text style={{ ...styles.subText, ...styles.flexwidthRow, ...styles.textCenter(index), ...styles.tableDataRow }}>
                                                {key === 'validity' ? new Date(dataObj[key])?.toLocaleDateString() : dataObj[key]}
                                            </Text>
                                        );
                                    })}
                                </>
                            );
                        })}
                    </View>
                </View>
                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} fixed />
            </Page>
        </Document>
    );
};

Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

const styles = StyleSheet.create({
    body: {
        paddingTop: 25,
        paddingBottom: 65,
        paddingHorizontal: 35
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    flexWidth25: {
        width: '25%',
        flexBasis: '25%',
        marginBottom: 10,
        textAlign: 'center'
    },
    flexGrow1: {
        flexGrow: 1
    },
    flexwidthRow: {
        flexBasis: '15.66666666666667%'
    },
    tableDataRow: {
        padding: 10,
        borderBottom: '1px solid #e0e0e0'
    },
    textCenter: (index) => ({
        textAlign: index === 0 ? 'start' : 'center'
    }),
    textStart: {
        textAlign: 'start'
    },
    backgroundHeading: {
        backgroundColor: '#13aa61',
        padding: 10
    },
    textWhite: {
        color: 'white'
    },
    flexWidth20: {
        width: '33.3%',
        flexBasis: '33%',
        marginBottom: 20,
        textAlign: 'center'
    },
    flexWidth75: {
        width: '75%',
        flexBasis: '75%',
        marginBottom: 20
    },
    dataBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        border: '1px solid #d3d3d3',
        borderRadius: '10px',
        padding: '5px',
        width: '250px',
        height: 'auto',
        margin: '5px'
    },
    textualData: {
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        marginLeft: '10px'
    },
    title: {
        fontSize: 14,
        textAlign: 'start',
        fontFamily: 'Oswald'
    },
    subtitle: {
        fontSize: 12,
        fontFamily: 'Oswald',
        color: '#505050',
        fontWeight: 'bold',
        textAlign: 'start'
    },
    subText: {
        fontSize: 10,
        fontFamily: 'Oswald',
        color: '#505050',
        fontWeight: 'bold',
        textAlign: 'start'
    },

    text: {
        margin: 12,
        fontSize: 14,
        textAlign: 'justify',
        fontFamily: 'Times-Roman'
    },
    image: {
        width: 100,
        height: 100
    },
    header: {
        fontSize: 18,
        marginBottom: 20,
        textAlign: 'center',
        color: 'black',
        fontWeight: 'semibold'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey'
    }
});

export default AgencyRewardsPdf;
